import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class MiTranslateLoaderService implements TranslateLoader {

  getTranslation(lang: string): Observable<any> {
    return of({
      Username: 'Email',
      Password: 'Password', 'Username is should be greater than x': 'Username is should be greater than {{minimumVal}}',
      comp_name: 'Company Name',
      about_comp: 'About Company',
      address: 'Address',
      address_col: 'Address :',
      rating_col: 'Rating :',
      noOfBookings: 'No. of Bookings :',
      address_line1: 'Address line 1',
      address_line2: 'Address line 2',
      web: 'Website',
      phone: 'Phone Number',
      fax: 'Fax',
      invalid: 'Invalid amount.',
      label_amount: 'Amount',
      invalid_hours: 'Invalid hours.',
      invalid_package: 'Invalid route name.',
      package: 'Route name required.',
      hours: 'Hours required.',
      cancellation: 'Cancellation fee required.',
      add_hours: 'Additional hours required.',
      addKm: 'Additional KM. required.',
      base_fare: 'Base fare required.',
      distance_amount: 'Invalid distance amount',
      distance_invalid: 'Invalid distance',
      category: 'Category type required.',
      service: 'Service type required.',
      distance: 'Distance required.',
      distance_fare: 'Distance fare required.',
      wait_fare: 'Wait time fare required.',
      ride_fare: 'Ride time fare required.',
      hours_time: 'Hours',
      mins: 'Minutes',
      secs: 'Seconds',
      route_fare: 'Fare required.',
      route_radius: 'Radius required.',
      route_radius_src: 'Radius required.',
      route_dest: 'Destination required.',
      pickup_time_validation: 'Please select valid time',
      add_destination_validation: 'Please add Destination',
      please_add_value_to_settings: 'Please add time, 0 is not allowed',
      at_least_one_destination: 'At least have one Destination',
      pickup_location_validation_msg: 'Please select proper pickup location',
      pickup_location: 'Pickup location required.',
      car_type_req: 'Car type Required.',
      hotel_req: 'Hotel Required',
      quotation_amount_req: 'Quotation amount required',
      route_pattern: 'Use numbers only.',
      route_length_src: 'Range 0.1 to 1 KM.',
      route_pattern_src: 'Use numbers only.',
      invalid_number: 'Invalid Number',
      f_name: 'First Name',
      l_name: 'Last Name',
      email: 'Email ID',
      document_type: 'Document type is required.',
      docRegNo: 'Registration No is required.',
      label_create_dept: 'Create Department',
      label_edit_dept: 'Edit Department',
      regId: 'Document ID',
      min_length: 'Minimum 3 characters required.',
      max_length: 'Exceeded character limit.',
      issue_date: 'Date of issue required.',
      expiry_date: 'Date of expiry required.',
      start_date: 'Start date is required.',
      end_date: 'End date is required.',
      document: 'Document required.',
      id_num: 'ID Num is required.',
      driver_name: 'Driver name is required.',
      name_pattern: 'Invalid name',
      pattern_alphabets: 'Use only alphabets.',
      phone_invalid: 'Enter a valid phone number.',
      number_pattern: 'Use numbers only.',
      fax_pattern: 'Invalid fax number',
      email_required: ' E-mail is required.',
      email_pattern: 'Invalid E-mail ID.',
      address_req: 'Address is required.',
      country_req: 'Country is required.',
      state_req: 'State is required.',
      company_name: 'Company name is required.',
      city_req: 'City is required.',
      approval_options: 'Select approval option',
      zipcode_req: 'Postal code is required.',
      zipcode_invalid: 'Invalid postal code.',
      transmission_type: 'Transmission type required.',
      invalid_staff_transport_name: 'Invalid name',
      contact_person_name: 'Contact person name is required.',
      label_contact_number: 'Contact Number',
      contact_number_require: 'Phone number is required.',
      comp_name_required: 'Company name required.',
      about_comp_required: 'About company required.',
      website_required: 'Website required.',
      phone_required: 'Phone number is required.',
      fax_required: 'Fax number required.',
      invalid_site: 'Invalid URL',
      service_type: 'Service Type',
      category_t: 'Vehicle Type',
      vehicle_no: 'Vehicle No',
      vehicle_details: 'Vehicle Make And Model',
      vehicle_details_req: 'Required vehicle make and model',
      vehicle_make: 'Vehicle Make',
      model_yr: 'Model year',
      capacity: 'Capacity',
      dev_id: 'Device Id',
      condition: 'Vehicle Condition',
      reg_no: 'Registration No',
      date_issue: 'Date of Issue',
      date_expiry: 'Date of Expiry',
      updated: 'Updated On',
      question_req: 'Question required.',
      answer_req: 'Answer required.',
      hotel_name: 'Hotel name required.',
      dispatcher_req: 'Dispatcher required ',
      corporate_name: 'Please enter corporate name.',
      corporate_code: 'Please enter corporate code.',
      name_invalid: 'Please enter valid name',
      corporate_contact_person_name: 'Please enter corporate person name.',
      corporateCareExecutive: 'Please select a care executive.',
      car_type: 'Car type required.',
      drop_location: 'Drop location required',
      booking_date: 'Pickup date required.',
      passenger_name: 'Passenger name required',
      Package_req: 'Package required',
      cmm_req: 'Car make & model required.',
      service_type_req: 'Service Type required',
      max_address: 'Maximum 100 characters allowed.',
      max_500_letters: 'Maximum 500 characters allowed.',
      max_50_letters: 'Maximum 50 characters allowed.',
      note_req: 'Charge code required.',
      charge_req: 'Note required.',
      deptAdmin_req: 'Assign Department Admin required.',
      name_req: 'Name required.',
      empId_req: 'Employee id required',
      empId_pattern: 'Invalid Employee id',
      department_req: 'Department required',
      message_passenger_not_assigned: 'Passenger data is not found.',
      message_driver_not_assigned: 'Driver not assigned',
      label_date_time: 'Date & time : ',
      label_date_time_list: 'Date & time',
      label_name: 'Name',
      label_phone: 'Phone :',
      label_phone_no: 'Phone',
      label_successful_trip: 'Successful Trips',
      label_distance_travelled: 'Distance Travelled (Km)',
      label_total_trip_amount: 'Total Trip Amount',
      label_credit: 'Credit',
      label_duty_time: 'Duty Time',
      label_duty_status: 'Status',
      label_average_rating: 'Average Rating',
      label_email: 'Email :',
      label_email_id: 'Email',
      lbl_email_id: 'Email ID',
      label_driver_details_header: 'Driver Details',
      label_passenger_details_header: 'Passenger Details',
      label_status: 'Status',
      label_rental_docs_uploaded: 'Rental Documents Uploaded',
      label_hotel_booking: 'Hotel Reservations',
      label_room_num: 'Room No',
      label_quotation_amount_accepted: 'Accepted Quotation Amount',
      label_room_no_req: 'Please Enter Room No.',
      label_booking: 'Reservations',
      label_trip_id: 'Trip id:',
      label_service_id: 'Service Type:',
      label_pickup: 'Pickup',
      label_hotel_success: 'Hotel added successfully.',
      label_pickup_date_time: 'PickUp Date & Time:',
      label_pickup_date_time_without_col: 'PickUp Date & Time',
      label_drop_date_time_without_col: 'Drop Date & Time',
      label_vehicle_type: 'Vehicle Type:',
      label_vehicle_type_header: 'Vehicle Type',
      noOfPackages: 'No. of Packages',
      label_add_vehicle_type: 'Add Vehicle Type',
      label_edit_vehicle_type: 'Edit Vehicle Type',
      label_no_of_passenger: `No. of Passenger's`,
      label_view_note_header: 'View Note',
      label_package: 'Package:',
      error_invalid_date: 'Invalid Date & time',
      label_km: 'Km',
      label_hr: 'Hr',
      label_mins: 'Mins',
      label_previous_quotation: 'Previous Quotations',
      label_service_type_header: 'Service Type',
      label_quotation_amount: 'Quotation amount',
      label_quotation_note: 'Note',
      label_quotation_reason_for_cancel: 'Reason',
      label_quotation_fare_estimate: 'Fare Estimate',
      error_quotation_amount: 'please enter quotation amount',
      invalid_amount: 'Invalid amount',
      error_quotation_note: 'Please enter quotation note',
      error_quotation_file: 'please upload quotation',
      forgot_password: 'Forgot Password?',
      select_area: 'Select Area',
      label_car_type: 'Car Type',
      label_car_make_model: 'Car make & model',
      label_pickup_location: 'Pickup Location',
      label_drop_location: 'Drop Location',
      file_upload_error: 'Entity is too large to upload',
      room_num_max_length: 'Max. 9 character allowed',
      label_passenger_name: 'Passenger Name',
      label_mobile_no: 'Phone No.',
      invalid_mobile_no: 'Invalid mobile No.',
      label_assign_driver: 'Assign Driver',
      label_driver: 'Driver',
      label_assign_drivers: 'Assign Drivers',
      label_note: 'Note',
      label_packages: 'Packages',
      label_CMM: 'Make',
      label_No_Passenger: 'No Passenger',
      label_from_date: 'From Date',
      label_start_date: 'Start Date',
      label_passenger_registered_with: 'Passenger Registered with',
      label_to_date: 'To Date',
      label_end_date: 'End Date',
      label_start_date_registration: 'Start Date (Registration)',
      label_role: 'Role',
      label_invalid_role: 'Invalid role, contact to server team',
      label_ID_Num: 'ID Num.',
      label_address_line_1: 'Address line 1',
      label_address_line_2: 'Address line 2',
      label_country: 'Country',
      label_state: 'State',
      label_city: 'City',
      label_approval_by_admin: 'Approval by Admin',
      label_zip_code: 'Postal Code',
      label_PO_box: 'PO box',
      label_assign_role: 'Assign Role',
      label_No: 'No.',
      label_read: 'READ',
      label_select_hotel: 'Select Hotel',
      label_driver_name: 'Driver Name',
      label_booking_type: 'Reservation Type',
      label_payment_mode: 'Payment Mode',
      label_invoice_date: 'Invoice Date',
      label_invoice_amount: 'Invoice Amount',
      label_refund_date: 'Refund Date',
      label_refund_amount: 'Refund Amount',
      err_refund_exceeds_value: 'Refund value exceeds total amount',
      label_passenger_type: 'Passenger Type',
      label_completed_bookings: 'Completed Reservations',
      label_cancelled_bookings: 'Cancelled Reservations',
      label_active_bookings: 'Active Reservations',
      label_total_amount: 'Total Amount',
      label_payment_received: 'Payment Received',
      label_payment_due: 'Payment Due',
      label_booking_code: 'Reservation Code',
      label_waiting_time: 'Waiting Time',
      label_km_in: 'KMs In',
      label_km_out: 'KMs Out',
      label_total_vehicles: 'Total Vehicles',
      label_taxi_drivers: 'Taxi Drivers',
      label_rental_car_drivers: 'Rental Car Drivers',
      label_hotel_dispatchers: 'Hotel Dispatchers',
      label_corporate_dispatchers: 'Corporate Dispatchers',
      label_no_of_bookings: 'No. of Reservations',
      label_month: 'Month',
      label_year: 'Year',
      label_years: 'Years',
      label_transmission_type: 'Transmission Type',
      label_registration_num: 'Registration Num',
      label_date_issue: 'Date of Issue ',
      label_date_expiry: ' Date of Expiry ',
      label_documents: 'Documents',
      label_document_type: 'Document Type',
      label_category: 'Category',
      label_VM: 'Vehicle Make',
      label_VM_name: 'Model Name',
      label_vehicle_no: 'Vehicle No.',
      label_model_year: 'Model Year',
      label_capacity: 'Capacity',
      label_car_condition: 'Car Condition',
      label_device_id: 'Device ID',
      category_req: ' Category Required',
      vehicle_number_req: ' Vehicle Number Required.',
      vehicle_number_pattern: 'Invalid vehicle number.',
      vehicle_model_year_req: 'Model Year Required.',
      vehicle_model_year_pattern: 'Invalid Model Year.',
      invalid_year_pattern: 'Invalid year format',
      capacity_req: 'Capacity Required.',
      two_digit_max: 'Only 2 digits allowed.',
      car_condition_req: 'Car Condition Required.',
      device_id_req: 'Device ID Required.',
      alpha_numeric_pattern: 'Use only alpha-numeric characters.',
      label_dashboard: 'Dashboard',
      label_sales_quotations: 'Sales Quotations',
      label_Passenger_type: 'Type of Passengers',
      label_Passengers: 'Passengers',
      label_Dispatchers: 'Dispatchers',
      label_Vehicles: 'Vehicles',
      label_Drivers: 'Drivers',
      label_Staff_Transport: 'Staff Transport',
      label_hotel: 'Hotel',
      label_Hotels: 'Hotels',
      label_corporate: 'Corporate',
      label_private: 'Private',
      label_App_Settings: 'App Settings',
      label_Settings: 'Settings',
      label_Reports: 'Reports',
      label_region: 'Region',
      label_add_region: 'Region',
      label_edit_region: 'Region',
      label_title: 'title',
      label_promo_title: 'Promo title',
      label_promo_title_require: 'Title is required',
      label_promo_code_require: 'Code is required',
      label_promo_date_range_require: 'Date range is required',
      label_usage_require: 'Limit is required',
      label_usage_pattern: 'invalid limit',
      label_discount_require: 'Discount is required',
      label_discount_pattern: 'Invalid Discount',
      label_promo_code: 'Promo Code',
      label_no_of_uses: 'No. of uses',
      label_usage_limit: 'Usage Limit',
      label_per_user_usage: 'Usage Limit per User',
      label_add_promo_code: 'Add Promo Code',
      label_update_promo_code: 'Edit Promo Code',
      label_date_range: 'Date Range',
      label_usage: 'Usage',
      label_usage_count: 'Usage Count',
      label_mode: 'Mode',
      label_discount: 'Discount',
      label_max_discount: 'Max discount',
      label_time_settings: 'Time Settings',
      label_Pricing: 'Pricing',
      label_Routes: 'Routes',
      label_edit: 'Edit',
      label_update: 'Update',
      label_delete: 'Delete',
      label_add: 'Add',
      label_package_name: 'Package Name',
      label_base_fare: 'Base Fare',
      label_distance: 'Distance',
      label_distance_fare: 'Additional Distance Fare Per KM',
      label_wait_time_fare: 'Wait Time Fare',
      label_ride_time_fare: 'Ride Time Fare',
      label_cancellation_fee: 'Cancellation Rate',
      label_actions: 'Actions',
      label_action: 'Action',
      label_details: 'Details',
      label_additional_hours: 'Additional Rate Per Hour',
      label_hours: 'Hours',
      label_additional_KM: 'Additional Rate Per KM ',
      label_category_type: 'Vehicle type',
      label_distance_unit: 'Distance (KM)',
      label_distance_for_base_fare: 'Distance (KMs) For Base Fare',
      label_send: 'Send',
      label_save: 'Save',
      label_book: 'Reserve',
      label_cancel: 'Cancel',
      please_select: 'Please Select',
      label_route_name: 'Route Name',
      label_view_route_on_map: 'View Route On Map',
      label_radius: 'Radius',
      label_radius_m: 'Radius(meters)',
      label_radius_unit: 'Radius(KM)',
      label_no_routes: 'No. of Routes',
      label_updated_on: 'Updated On',
      label_Radius_Meters: 'Radius (Meters)',
      label_destination: 'Destinations',
      label_add_destination: 'Add Destination',
      label_fare: 'Fare',
      label_add_route: 'Add Route',
      label_update_route: 'Edit Route',
      label_delete_route_msg: 'Are you sure do you really want to delete this bus route?',
      label_add_packages: 'Add Packages',
      label_update_packages: 'Update Packages',
      label_FAQ: 'FAQ',
      label_description: 'Description',
      label_terms_conditions: 'Terms & Conditions',
      label_privacy_policy: 'Privacy Policy',
      label_rental_privacy_policy: 'Rental Policy',
      label_chauffeur_privacy_policy: 'Chauffeur Policy',
      label_password_match: 'password does not match',
      label_docs_validation: 'Add at least one document',
      label_otp: 'Please enter OTP',
      label_otp_msg: 'We will send One Time Password (OTP) on your registered email to reset password.',
      label_current_km: 'Please enter Current KM',
      label_enter: 'Please enter',
      invalid_otp: 'Invalid OTP',
      label_please_enter_otp:'Please enter OTP',
      label_our_partners: 'Our Partners',
      label_choose: 'Choose',
      label_question: 'Question',
      label_answer: 'Answer',
      label_clear: 'Clear',
      label_edit_term_Condition: 'Edit Terms & Conditions',
      label_Terms_Use: 'Terms & Conditions',
      label_edit_privacy_policy: 'Edit Privacy Policy',
      label_edit_cancellation_policy: 'Edit Cancellation Policy',
      label_edit_contact_us: 'Edit Contact Us',
      label_edit_rental_policy: 'Edit Rental Policy',
      label_edit_chauffeur_policy: 'Edit Chauffeur Policy',
      label_add_partner: 'Add Partner',
      label_id: 'ID',
      label_hash: '#',
      label_corporate_info: 'Corporate Info',
      label_contact_person: 'Contact Person',
      label_department_count: 'Total Departments',
      label_registration_Date: 'Registration Date',
      label_total_bookings: 'Total Reservations',
      label_online_bookings: 'Online Reservations',
      label_instance_booking: 'Instance Reservations',
      label_deactivate: 'Deactivate',
      label_activate_edit: 'Active & Edit',
      label_activate: 'Active',
      label_Total: 'Total',
      label_active: 'Activate',
      label_cancelled: 'Cancelled',
      label_completed: 'Completed',
      label_new: 'New',
      label_regret: 'Regret',
      label_corporate_information: 'Corporate Information',
      label_package_pricing: 'Package Pricing',
      label_route_pricing: 'Route Pricing',
      label_corporate_name: 'Corporate Name',
      label_corporate_code: 'Corporate Code',
      label_contact_person_name: 'Contact Person Name',
      label_assign_corporate_executive: 'Assign Corporate Care Executive',
      label_save_next: 'Save & Next',
      label_save_quit: 'Save & Quit',
      label_add_pricing: 'Add Pricing',
      label_back: 'Back',
      label_finish: 'Finish',
      label_next: 'Next',
      label_quit: 'Quit',
      label_additional_hours_fee: 'Additional Hours Rate',
      label_hotel_info: 'Hotel Info',
      label_dispatcher_name: 'Dispatcher Name',
      label_dispatcher_no: 'Dispatcher No',
      label_hotel_name: 'Hotel Name',
      label_dispatcher_details: 'Dispatcher Details',
      label_hotel_information: 'Hotel Information',
      label_current_location: 'Current Location',
      labe_notifications_to: 'to',
      label_notifications: 'Notifications',
      label_date_and_time: 'Date & time',
      label_resend: 'Resend',
      label_vehicle_info: 'Vehicle info',
      label_vehicle_count: 'Vehicle Count',
      label_assign: 'Assign',
      label_add_documents: 'Add Documents',
      label_add_documents_details: 'Attached Documents Details',
      label_rating: 'Rating',
      label_num: 'Num.',
      label_yes: 'Yes',
      label_no: 'No',
      label_all: 'All',
      label_busy: 'Busy',
      label_available: 'Available',
      label_off_duty: 'Off Duty',
      label_S_NO: 'S.NO',
      label_vehicle: 'vehicle',
      label_access_name: 'Access Name',
      label_dispatcher: 'dispatcher',
      label_trip_completed: 'Trips Completed',
      label_user_type: 'User Type',
      label_vehicleNumber: 'Vehicle Number ',
      label_driverID: 'Driver ID',
      label_trip_date: 'Pickup Date time',
      label_trip_amount: 'Trip Amount',
      label_booking_date_time: 'Reservation Date & Time',
      label_trip_total: 'Trip fare',
      label_BookingId: 'Booking ID',
      label_trip_status: 'Trip Status',
      label_tripID: 'Trip ID',
      label_source_address: 'Source Address',
      label_destination_address: 'Destination Address',
      label_reset: 'Reset',
      label_passenger: 'Passenger',
      label_pickup_drop_location: 'Pickup & Drop location',
      label_booking_ID: 'Booking ID',
      label_upload_quote_pdf: 'Upload Quote (PDF)',
      label_booking_date: 'Reservation Date',
      label_upload_quote: 'Upload Quote',
      label_start_trip: 'Start Trip',
      label_end_trip_message: 'Trip is ended successfully',
      label_extend_trip: 'Extend Trip',
      label_end_trip: 'End Trip',
      label_cancel_trip: 'Cancel Trip',
      label_security_check: 'Security Check',
      label_delivery_check: 'Delivery Check',
      label_car_return_check: 'Car Return Check',
      label_return_security_check: 'Return Security Check',
      label_resend_quote: 'Resend Quote',
      label_taxi: 'Taxi',
      label_rental_car: 'Rental Car',
      label_chauffeur: 'Chauffeur',
      label_booking_status: 'Reservation Status',
      label_search: 'Enter text to search..',
      label_charge_code: 'Charge Code',
      label_department: 'Department',
      label_department_admin: 'Department Admin',
      label_employeeID: 'Employee ID',
      label_active_trips: 'Active Trips',
      label_on_trips: 'On Trip',
      label_assign_department: 'Assign Department Admin',
      label_department_name: 'Department Name',
      label_employee_name: 'Employee Name',
      label_no_trips: 'No. of Trips',
      label_view_details: 'View Details',
      label_mark_vip: 'Mark As VIP',
      label_approve: 'Approve',
      label_reject: 'Reject',
      label_pending_approval: 'Pending for Approval',
      label_manage_employee: 'Manage Employees',
      label_manage_departments: 'Manage Departments',
      label_pricing_details: 'Pricing Details',
      label_taxi_service: 'Taxi Service',
      label_rental_car_service: 'Rental Car Service',
      label_chauffeur_service: 'Chauffeur Service',
      label_start_end_date: 'Start-End Date',
      label_pickup_time: 'Pickup Time',
      label_staff_transport: 'staff-transport',
      label_day: 'Days',
      label_Assign_vehicle: 'Assign Vehicle',
      label_total_fare: 'Total Fare',
      label_holiday: 'Holidays',
      label_another_drop_location: 'Another Drop Location',
      label_type: 'Type',
      label_is_ac: 'Is AC ?',
      required_is_ac: 'AC type is required.',
      label_view_route: 'View Route info',
      label_route_information: 'Route Information',
      label_renew_package: 'Renew Package',
      label_track_driver: 'Track Driver',
      label_car_no: 'Car No',
      charge_code_max_length: 'Allowed maximum 4 character',
      label_cancellation: 'Cancellation Reasons',
      label_cancellation_reason: 'Cancellation Reason',
      label_booking_cancel: 'Cancel Reservation',
      label_rating_comments: 'Rating & Comments',
      label_reply: 'Reply',
      label_cancel_reason: 'Cancel Reason',
      label_reason: 'Reason',
      label_trip_history: 'Trip History',
      label_forgot_password: 'Forgot Password',
      label_forgot: 'User Name/ Email /Phone No.',
      cancel_reason_req: 'Cancel Reason Required.',
      label_cancel_booking: 'Cancel Reservation',
      label_country_code: 'Country Code',
      country_code_required: 'Country code is required.',
      country_code_invalid: 'Country code invalid',
      booking_details_result: 'No Reservation record found.',
      booking_comment_details: 'No comment',
      comment_heading: 'Rating & Comments',
      label_driver_type: 'Driver Type',
      label_confirm_extend_package: 'Do you really want to Extend Package?',
      label_extend_package_confirmation_header: 'Extend Package Confirmation',
      label_confirm_emp_confirm_booking_p1: 'Are you sure that you want to ',
      label_confirm_emp_confirm_booking_p2: ' this reservation',
      label_amenities: 'Amenities',
      label_vehicle_name: 'Vehicle Name',
      required_vehicle_name: 'Vehicle name is required.',
      hint_vehicle_name: '(Enter a nickname to distinguish this vehicle in truck)',
      label_vin_sn: 'VIN/SN',
      required_vin_sn: 'VIN/SN is required.',
      hint_vin: '(Vehicle Identification Number)',
      required_vehicle_type: 'Type is required.',
      hint_type: '(e.g. Sleeper, Semi Sleeper, Hybrid, etc)',
      required_vehicle_year: 'Year is required.',
      hint_year: '(e.g. 1992, 2000, etc)',
      label_make: 'Make',
      required_vehicle_make: 'Make is required.',
      hint_make: '(e.g. Volvo, Benz, etc)',
      label_model: 'Model',
      required_vehicle_model: 'Model is required.',
      hint_model: '(e.g. 4Runner, Yukon, etc)',
      label_license_plate: 'License Plate',
      required_license_plate: 'License Plate is required.',
      label_registration_state: 'Registration State/Province',
      label_upload_image: 'Upload Image',
      required_upload_image: 'Image is required.',
      label_identification: 'Identification',
      label_classification: 'Classification',
      label_operator: 'Operator',
      required_operator: 'Operator is required.',
      label_ownership: 'Ownership',
      required_ownership: 'Ownership is required.',
      hint_ownership: '(Owned, Leased, Rented, Custom)',
      label_additional_details: 'Additional Details',
      label_fuel_type: 'Fuel Type',
      required_fuelType: 'Fuel type is required.',
      label_fuel_capacity: 'Fuel Capacity',
      required_fuelCapacity: 'Fuel capacity is required.',
      label_vehicle_color: 'Vehicle Color',
      required_vehicle_color: 'Vehicle color is required.',
      label_layout_type: 'Layout Type',
      required_layout_type: 'Layout type required.',
      hint_layout: '(e.g. 1x2, 2x1, 1x1, 2x2)',
      label_seat_capacity: 'Seat Capacity',
      required_seat_capacity: 'Seat capacity is required.',
      hint_fuel_capacity: '(In Litre)',
      label_document_name: 'Document Name',
      required_registration_copy: 'Registration copy is required.',
      upload_documents: 'Upload',
      label_choose_file: 'Choose File',
      label_add_more_documents: 'Add More Documents',
      invalid_fuel_capacity_pattern: 'Invalid fuel capacity.',
      registration_copy: 'Registration Copy',
      transport_permission: 'Transport Permission',
      fitness_certificate: 'Fitness Certificate',
      puc: 'PUC',
      state_permission: 'State Permission',
      all_country_permission: 'All Country Permission',
      label_previous: 'Previous',
      label_from: 'From',
      label_to: 'To',
      label_bus: 'Buses',
      label_manage_booking: 'Manage Reservations',
      label_bus_seasonal_fares: 'Bus Seasonal Fares',
      label_add_new_bus: 'Add New Bus',
      label_bus_name: 'Bus Name',
      label_bus_no: 'Bus No',
      label_reg_no: 'Reg Number',
      label_bus_id: 'Bus Id',
      label_manage_bus: 'Manage Buses',
      label_delete_bus_msg: 'Are you sure do you really want to delete this bus?',
      label_view: 'View',
      invalid_seat_capacity_pattern: 'Invalid seat capacity.',
      label_new_booking: 'Add New Reservation',
      label_new_cancellation_Policy: 'Add New Cancellation Policy',
      label_error_cancel_booking: 'Error occurred during reservation cancellation, Please try later.',
      label_success_cancel_booking: 'Reservation cancelled successfully.',
      label_success_booking: 'Seat booked successfully.',
      label_booked_by: 'Reserved By',
      label_booked_seats: 'Reserved Seats',
      label_count: 'Count',
      label_travel_information: 'Travel Information',
      label_journey_date: 'Journey Date',
      label_departure_date: 'Departure Date',
      label_boarding_point: 'Boarding Point',
      label_dropping_point: 'Dropping Point',
      label_bus_operator: 'Bus Operator',
      label_bus_type: 'Bus Type',
      label_total_seat: 'Total Seat',
      label_total_seats: 'Total Seats',
      label_seat_no: 'Seat No.',
      label_locality: 'Locality',
      label_opted_facilities: 'Opted Facilities',
      label_guest_information: 'Guest Information',
      label_customer_information: 'Customer Information',
      label_select_service_type: 'Select service type',
      label_add_new_fare: 'Add New Fare',
      label_price_increase: 'Price Increase (+/-)%',
      label_save_and_close: 'Save & Close',
      label_seasonal_fare: 'Seasonal Fare',
      required_from_date: 'From date is required',
      required_to_date: 'To date is required',
      required_increase_value: 'Price increase is required',
      invalid_price: 'Invalid price',
      label_bus_manage_schedule: 'Manage Schedules',
      label_time: 'Time',
      label_download_sample: 'Download Sample',
      label_add_new_schedule: 'Add New Schedule',
      label_schedule_id: 'Schedule Id',
      label_schedule_name: 'Schedule Name',
      label_start_time: 'Start Time',
      label_booking_open_till: 'Open Till',
      label_download: 'Download',
      label_upload_schedule_file: 'Upload Schedule File',
      label_upload_fare_file: 'Upload Fare File',
      label_upload_fare: 'Upload Fare',
      label_download_fare: 'Download Fare',
      label_upload_schedule: 'Upload Schedule File',
      label_download_schedule: 'Download Schedule',
      label_live_schedules: 'Live Schedules',
      label_confirm_update_schedule_msg: 'We will delete all the fares associated with it. Are you sure you want to continue?',
      label_incomplete_schedules: 'Incomplete Schedules',
      label_upload_file_msg: 'Use Upload Button To Upload File',
      fill_up_required_field: 'Please fill up all required field',
      expiry_date_should_be_greater: 'Expiry date should be greater than issue date.',
      to_date_should_be_greater: 'To date should be greater than from date.',
      label_manage_routes: 'Manage Routes',
      label_add_new_route: 'Add New Route',
      label_save_route: 'Save Route',
      label_route_id: 'Route Id',
      label_stops: 'Stops',
      label_route_title: 'Route Title',
      label_add_stops: 'Add Stops',
      label_add_stop: 'Add Stop',
      label_stop: 'Stop',
      route_title_required: 'Route title is required.',
      from_required: 'From is required.',
      from_should_be_google_error: 'Please select From from google suggestion list.',
      to_required: 'To is required.',
      to_should_be_google_error: 'Please select To from google suggestion list.',
      stops_should_be_google_error: 'Please select Stops from google suggestion list.',
      search: 'Search',
      label_departure_time: 'Departure Time',
      label_price_range: 'Price Range',
      label_facilities: 'Facilities',
      label_apply: 'Apply',
      label_manage_operators: 'Manage Operators',
      label_add_new_operator: 'Add New Operator',
      label_operator_name: 'Operator Name',
      required_operator_name: 'Operator name is required.',
      label_email_address: 'Email',
      label_contact_details: 'Contact Details',
      label_bus_details: 'Bus Details',
      label_guest_details: 'Guest Details',
      label_payment: 'Payment',
      label_payment_info: 'Payment Info',
      label_continue: 'Continue',
      label_view_photos: 'View Photos',
      label_boarding_points: 'Boarding Points',
      label_fare_estimation: 'Fare Estimation',
      label_split_fare_detail_msg: '(Split fare details will be shown on the payment screen.)',
      label_drop_points: 'Drop Points',
      label_selected: 'Selected',
      label_occupied: 'Occupied',
      label_ladies_only: 'Ladies Only',
      label_locked: 'Locked',
      label_manage_drivers: 'Manage Drivers',
      label_add_driver: 'Add Driver',
      label_delete_driver_msg: 'Are you sure do you really want to delete this Driver?',
      add_at_least_one_document: 'Please add at least one document.',
      one_document_required: 'At least one document required.',
      one_file_required: 'Please attach at least one file to document.',
      label_bus_seat_layouts: 'Bus Seat Layouts',
      label_add_seat_layout: 'Add Seat Layout',
      label_layout_name: 'Layout Name',
      label_no_of_deck: 'Deck',
      label_delete_layout_msg: 'Are you sure do you really want to delete this layout?',
      label_first_name_required: 'First Name is required.',
      label_invalid_first_name: 'First Name is invalid.',
      label_last_name_required: 'Last Name is required.',
      label_invalid_last_name: 'Last Name is invalid.',
      label_seat_type: 'Seat Type',
      label_age: 'Age',
      label_gender: 'Gender',
      label_gender_required: 'Please select gender type.',
      label_discount_promo_code: 'Discount and Promo code',
      label_enter_coupon_code: 'Enter coupon code',
      label__holder_name: 'Card Holder Name',
      label_card_number: 'Card Number',
      label_expiry_date: 'Expiry Date',
      label_cvv_code: 'CVV Code',
      label_make_payment: 'Make Payment',
      label_bus_info: 'Bus Info',
      label_bus_dashboard: 'Bus Dashboard',
      label_departure: 'Departure',
      label_arrival: 'Arrival',
      label_price: 'Price',
      label_select: 'Select',
      label_save_card_details_msg: 'Save Card Details For Next Transaction',
      label_invalid_user: 'Invalid User Name/ Email /Phone No.',
      label_driver_location: 'Driver Location',
      label_report_driver_login_logout: 'Driver Login-Logout',
      label_report_driver_on_duty: 'Driver On Duty',
      label_report_driver_income: 'Driver Income',
      label_report_driver_mileage: ' Driver Mileage',
      label_report_driver_performance: 'Driver Performance',
      label_report_car_mileage: 'Car Mileage',
      label_report_transaction: 'Transaction',
      label_report_refund: 'Refund',
      label_refund_successfully: 'Amount refunded successfully.',
      label_report_promo_code: 'Promo Code',
      label_report_referral_credit: 'Referral Credit',
      label_report_passenger_feedback: 'Passenger Feedback',
      label_report_feedback: 'Feedback',
      label_mode_promo_code: 'Promo Code Mode',
      label_mode_usage_type: 'Usage Type',
      label_credit_amount: 'Credit Amount',
      label_referred_on: 'Referred on',
      label_total_buses: 'Total Buses',
      label_in_journey: 'In Journey',
      label_idle: 'Idle',
      label_card: 'Card',
      label_cash: 'Cash',
      label_cfop: 'CFOP',
      label_app_booking: 'App Reservation',
      label_walking_booking: 'Walk-In Reservation',
      label_contact_us: 'Contact Us',
      label_cancel_policy: 'Cancellation Policy',
      label_manage_cancel_policy: 'Manage Cancellation Policy',
      label_message: 'Message',
      label_date: 'Date',
      label_delete_schedule_msg: 'Are you sure do you really want to delete this schedule?',
      label_delete_fare_msg: 'Are you sure do you really want to delete fare?',
      label_preview: 'Preview',
      label_preview_brackets: '(Preview)',
      label_12_AM_to_6_AM: '12 AM to 6 AM',
      label_12_PM_to_6_PM: '12 PM to 6 PM',
      label_6_AM_to_12_PM: '6 AM to 12 PM',
      label_6_PM_to_12_AM: '6 PM to 12 AM',
      label_1_to_300: '01-300',
      label_300_to_600: '300-600',
      label_600_to_900: '600-900',
      label_900_to_1200: '900-1200',
      label_1200_above: '1200 Above',
      label_1200_90000: '1200-90000',
      label_male: 'Male',
      label_female: 'Female',
      label_invalid_age: 'Invalid age.',
      label_seat_required: 'Please select at least one seat.',
      label_boarding_point_required: 'Boarding point is required.',
      label_drop_point_required: 'Drop point is required.',
      label_api_error_boarding_point: 'Error occurred in getting boarding Point type.',
      label_api_error_drop_point: 'Error occurred in getting dropping Point type.',
      label_api_error_facility: 'Error occurred in getting facilities type.',
      label_api_error_operator: 'Error occurred in getting operator type.',
      label_api_error_bus_type: 'Error occurred in getting bus type.',
      label_bus_manage_tours: 'Manage Tours',
      label_manage_tour: 'Manage Tour',
      label_doc_number_required: 'Document number is required.',
      label_broadcast_message: 'Broadcast Messages',
      label_app_bookings: 'App Reservations',
      label_tours_started: 'Tours Started',
      label_tours_completed: 'Tours Completed',
      label_tours_planned: 'Tours Planned',
      label_advance_duration: 'Advance Reservation Duration (Days)',
      label_duration_error: 'Please enter valid days.',
      label_duration_min_error: 'Minimum reservation duration should be 1 day.',
      label_duration_max_error: 'Maximum reservation duration should be 365 day.',
      label_advance_booking_days: 'Advance Reservation (Days)',
      label_application_form: 'Applicable From',
      label_application_to: 'Applicable To',
      label_fares: 'Fares',
      label_manage_contents: 'Manage Contents',
      label_active_days: 'Active Days',
      label_layout_title: 'Layout Title',
      label_ac: 'A/C',
      label_AC: 'AC',
      label_landmark: 'Landmark',
      label_source: 'Source',
      label_delete_schedule: 'Delete Schedule',
      label_view_fare: 'View Fare',
      label_update_schedule: 'Update Schedule',
      label_view_schedule: 'View Schedule',
      label_city_from: 'City From',
      label_city_to: 'City To',
      label_class: 'Class',
      label_travel_type: 'Travel Type',
      label_monday: 'Mon',
      label_tuesday: 'Tue',
      label_wednesday: 'Wed',
      label_thursday: 'Thu',
      label_friday: 'Fri',
      label_saturday: 'Sat',
      label_sunday: 'Sun',
      label_update_fare: 'Update Fare',
      label_schedule_num: 'Schedule Number',
      label_add_fare: 'Add Fare',
      label_delete_fare: 'Delete Fare',
      label_post: 'Post',
      label_select_type: 'Select Type',
      label_select_persons: 'Select Persons',
      label_drop: 'Drop',
      label_taxes: 'Taxes',
      label_tax_name: 'Tax Name',
      label_add_new_tax: 'Add New Tax',
      label_select_source_destination: 'Please select valid Source and Destination points.',
      label_fare_not_found: 'No fare associate with this route, Please contact to the operator.',
      label_invalid_coupon_code: 'Invalid coupon code.',
      label_coupon_code_applied: 'Coupon code applied successfully.',
      label_seats: 'Seats',
      label_route_bus_not_found: 'Sorry! No bus found on this route for a given search parameter.',
      label_assigned_bus: 'Assigned Bus',
      label_bus_manage_refund: 'Manage Refunds',
      label_transaction_id: 'Transaction Id',
      label_transaction_status: 'Transaction Status',
      label_transaction_amount: 'Transaction Amount',
      label_refund_type: 'Refund Type',
      label_refunded_amount: 'Refund Amount',
      label_pending_refund: 'Pending Refund',
      label_successful_refund: 'Successful Refund',
      label_paid_fare: 'Paid Fare',
      label_cancelled_seats: 'Cancelled Seats',
      label_make_refund: 'Make Refund',
      file_size_limit: 'This file is too large. The maximum size allowed is 10MB',
      vehicle_assigned_already: 'Are you sure do you really want to assign this Driver? He is already assigned to other vehicle',
      driver_is_not_assigned: 'Driver is not assigned',
      label_manage_taxes: 'Manage Taxes',
      label_user_management: 'User Management',
      label_marketing: 'Marketing',
      label_manage_user: 'Manage Users',
      label_percentage: 'Percentage',
      invalid_percentage: 'Invalid percentage.',
      percentage_required: 'Percentage is required.',
      required_tax_name: 'Tax name is required.',
      label_new_user: 'New User',
      label_existing_user: 'Existing User',
      existing_user_required: 'Please select existing User',
      invalid_existing_user_required: 'Existing User details not found',
      label_promo_code_required: 'Please enter valid coupon code.',
      label_add_new_cancellation_rule: 'Add New Cancellation Rule',
      label_policy_type: 'Policy Type',
      label_add_new_policy_rule: 'Add New Policy Rule',
      label_cancellation_description_placeholder: 'Please enter some description about cancellation policy.',
      label_before_tour_start: 'Before Tour start',
      label_day_or_hour: 'Day / Hour',
      label_format: 'Format',
      label_select_policy_time_format: 'Select Policy Time Format',
      label_policy_rule: 'Are you sure do you really want to delete this policy rule?',
      label_before_tour_start_required: 'Before tour start must be grater than zero.',
      label_error_percentage_not_zero: 'Percentage must be greater than zero.',
      label_effective_from_required: 'Effective from is required.',
      label_policy_description_required: 'Policy description is required.',
      label_at_least_one_policy_rule_required: 'Please add at least one policy rule.',
      label_delete_cancellation_policy: 'Are you sure do you really want to delete this policy?',
      label_policy_added_successfully: 'Policy added successfully.',
      label_policy_updated_successfully: 'Policy updated successfully.',
      label_completed_tours: 'Completed Tours',
      label_delete_tax_msg: 'Are you sure do you really want to delete this tax?',
      label_total_collection: 'Total Collection',
      label_online_collection: 'Online Collection',
      label_instance_collection: 'Instance Collection',
      label_boarding_stop: 'Boarding Stop',
      label_dropping_stop: 'Dropping Stop',
      label_date_picker_placeholder: 'Enter date in mm/dd/yyyy format.',

      // mi grid v2
      aria_label_table_header_with_parameter: '{{name}} header',
      label_no_records_found: 'No records found',
      aria_label_download_excel: 'Download excel file',
      aria_label_download_pdf: 'Download pdf file',
      aria_label_table_header_announce_sort_asc: 'Change sort in ascending order for a column ',
      aria_label_table_header_announce_sort_desc: 'Change sort in descending order for a column ',
      aria_label_paginator_go_to_next: 'Go to next page',
      aria_label_paginator_go_to_previous: 'Go to previous page',
      aria_label_paginator_go_to_first: 'Go to first page',
      aria_label_paginator_go_to_last: 'Go to last page',
      // confirmation dialog

      aria_label_confirmation_dialog: 'confirmation dialog',
      aria_label_confirmation_dialog_close_button: 'close',

      // profile menu
      aria_label_profile: 'user profile',
      aria_label_open_sidebar: 'open sidebar',
      aria_label_close_sidebar: 'close sidebar',

      // menu handles
      menu_bookings: 'Reservations',
      menu_corporate_bookings: 'Corporate Reservations',
      menu_hotel_bookings: 'Hotel Reservations',
      menu_sales_quotation: 'Sales Quotations',
      menu_admin_dashboard: 'Dashboard',
      menu_corporate_dashboard: 'Corporate Dashboard',
      menu_passengers: 'Passengers',
      menu_dispatchers: 'Dispatchers',
      menu_vehicles: 'Vehicles',
      menu_drivers: 'Drivers',
      menu_staff_transport: 'Staff Transport',
      menu_hotels: 'Hotels',
      menu_corporate: 'Corporate',
      menu_app_settings: 'App Settings',
      menu_settings: 'Settings',
      menu_notifications: 'Notifications',
      menu_reports: 'Reports',
      menu_corporate_reports: 'Corporate Reports',
      menu_corporate_approval: 'Corporate Approval',
      menu_corporate_pending_approval: 'Pending for Approval',
      menu_corporate_manage_employee: 'Manage Employees',
      menu_corporate_manage_departments: 'Manage Departments',
      menu_corporate_settings: 'Corporate Settings',
      menu_user_management: 'User Management',
      menu_marketing: 'Marketing',
      // app settings access
      access_get_privacy_policy: 'Get Privacy Policy',
      access_get_contact_support: 'Get Contact Support',
      access_get_rental_policy: 'Get Rental Policy',
      access_getChauffeur_policy: 'Get chauffeur Policy',
      access_update_about_us: 'Update About Us',
      access_update_terms_and_conditions: 'Update Terms And Conditions',
      access_get_tenant_by_id: 'Get Tenant By Id',
      access_add_faq: 'Add FAQ',
      access_update_faq: 'Update FAQ',
      access_get_faq: 'Get FAQs',
      access_add_partner: 'Add Partner',
      access_update_partner: 'Update Partner',
      access_update_privacy_policy: 'Update Privacy Policy',
      access_delete_partner: 'Delete Partner',
      access_get_partners: 'Get Partners',
      access_get_service_types: 'Get Service Types',
      access_get_labels: 'Get Labels',
      access_get_service_area: 'Get Service Area',
      access_get_terms_and_conditions: 'Get Terms And Conditions',
      access_get_about_us: 'Get About Us',
      access_update_rental_policy: 'Update Rental Policy',
      access_update_chauffer_policy: 'Update Chauffer Policy',
      // Bookings accesses
      access_get_corporate_booking_grid: 'Get Corporate Reservations Grid',
      access_cancel_trip: 'Cancel Trip',
      access_send_verification_code_to_passenger: 'Send Verification Code To Passenger',
      access_get_booking_bill_details: 'Get Reservation Bill Details',
      access_add_driver_trip_emergency: 'Add Driver Trip Emergency',
      access_add_passenger_trip_emergency: 'Add Passenger Trip Emergency',
      access_get_reasons_by_type: 'Get Reasons By Type',
      access_get_corporate_pending_approval_grid: 'Get Corporate Pending Reservation Approvals Grid',
      access_approve_booking: 'Approve Reservations',
      access_get_booking_estimation: 'Get Reservation Estimation',
      access_get_booking_details_by_trip_id: 'Get Reservation Details By TripId',
      access_extend_booking_package: 'Extend Reservation Package',
      access_update_rental_booking_security_checks: 'Update Rental Reservation Security Checks',
      access_end_rental_booking: 'End Rental Reservation',
      access_get_user_active_bookings: 'Get User Active Reservations',
      access_bookings_export_to_excel: 'Reservations Export To Excel',
      access_add_passenger_trip_rating: 'Add Passenger Trip Rating',
      access_add_driver_trip_rating: 'Add Driver Trip Rating',
      access_add_booking: 'Add Reservation',
      access_add_corporate_booking: 'Add Corporate Reservation',
      access_add_rental_booking: 'Add Rental Reservation',
      access_add_chauffer_booking: 'Add chauffeur Reservation',
      access_get_passenger_bookings_list: 'Get Passenger Reservations List',
      access_get_bookings_by_user_type: 'Get Reservations By User Type',
      access_get_booking_grid: 'Get Reservation Grid',
      access_bookings_export_to_pdf: 'Reservation Export To pdf',
      access_get_booking_details: 'Get Reservation Details',
      access_cancel_booking: 'Cancel Reservation',
      access_assign_driver: 'Assign Driver',
      access_acknowledge_booking_by_driver: 'Acknowledge Reservation By Driver',
      access_accept_trip: 'Accept Trip',
      access_start_trip: 'Start Trip',
      access_end_trip: 'End Trip',
      access_update_booking_bill_cash: 'Update Reservation Bill Cash',
      access_update_booking_bill_credit_note: 'Update Reservation Bill Credit Note',
      access_update_booking_driver_arrived: 'Update Reservation Driver Arrived',
      access_add_trip_comment_reply: 'Add Trip Comment Reply',
      access_get_note_by_trip_id: 'Get Note By TripId',
      resend_notification_message: 'Do you really want to resend the notification?',
      delete_faq: 'Are you sure you want to delete the FAQ?',
      delete_partner: 'Are you sure you want to delete this partner?',
      action_note1: 'Are you sure you want to ',
      corporate_action_note2: ' this Corporate?',
      dispatcher_action_note2: '  this dispatcher ?',
      invalid_corporate_message: 'Unable to load corporate details.',
      edit_company_info: 'Edit Company Info',
      access_assign_bus: 'Assign Bus',

      // corporate booking approval
      access_get_pending_approvals_grid: 'Get Pending Approvals Grid',
      access_approval_reject_corp_booking: 'Approve/Reject Corporate Reservation',
      access_get_Corporate_booking_details: 'Get Corporate Reservation Details',
      access_get_charge_codes_for_corporate: 'Get Charge Codes For Corporate',
      access_get_corporate_and_dept: 'Get Corporate And Departments',
      // corporate dashboard
      access_get_emergency_details: 'Get Emergency Details',
      access_get_corp_dash_emergency_grid: 'Corporate Dashboard Emergencies Grid',
      access_get_corp_dash_graph: 'Get Corporate Dashboard Graph Data',
      access_get_corporate_dash: 'Get Corporate Dashboard Data',
      // corporate
      access_corp_count: 'Corporate Count',
      access_corp_search: 'Search Corporate',
      access_corp_export_to_pdf: 'Corporate Export To PDF',
      access_corp_export_to_xls: 'Corporate Export To Excel',
      access_corp_activate: 'Activate Corporate',
      access_corp_and_dept: 'Get Corporate And Departments',
      access_corp_dept_by_code: 'Get Corporate Departments By Corporate Code',
      access_corp_add: 'Add Corporate',
      access_corp_details: 'Get Corporate Details',
      access_corp_update: 'Update Corporate',
      access_corp_grid: 'Get Corporate Grid',
      access_corp_booking_history: 'Corporate Reservation History',
      // corporate settings
      access_corp_setting_get_charge_code: 'Get Charge Codes For Corporate',
      access_corp_setting_charge_code_grid: 'Charge Code Grid',
      access_corp_setting_add_change_code: 'Add Charge Code',
      access_corp_setting_routes_grid: 'Routes Grid',
      access_corp_setting_partner_package_grid: 'Partner Packages Grid',
      // dashboard
      access_admin_dash_emergency_and_booking_details: 'Emergency and reservation details',
      access_admin_dash_emergency_grid: 'Emergency Grid',
      access_admin_dash_get: 'Get Dashboard Data',
      access_admin_dash_get_graph: 'Get Dashboard Graph Data',
      // dispatchers
      access_c_get_details: 'Get Dispatcher Details',
      access_display_update: 'Update Dispatcher',
      access_display_export_to_pdf: 'Dispatchers Data For Export To PDF',
      access_display_export_to_xls: 'Dispatchers Data For Export To Excel',
      access_display_get_count: 'Get Dispatchers Count',
      access_display_grid: 'Dispatchers Grid',
      access_display_search: 'Search Dispatchers',
      access_display_get_booking_history: 'Get Dispatcher Reservation History',
      access_display_get_roles: 'Get Dispatcher Roles',
      access_display_activate_deactivate: 'Activate/Deactivate Dispatcher',
      access_display_add: 'Add Dispatcher',
      // drivers
      access_driver_get: 'Get Driver Info',
      access_driver_update: 'Update Driver',
      access_driver_search: 'Search Driver',
      access_driver_activate_deactivate: 'Activate/Deactivate Driver',
      access_driver_grid: 'Drivers Grid',
      access_driver_export_to_xls: 'Drivers Export To Excel',
      access_driver_export_to_pdf: 'Drivers Export To PDF',
      access_driver_get_count: 'Get Drivers Count',
      access_driver_get_vehicle_and_assign: 'Get Vehicle Assigned To Driver',
      access_driver_update_duty_status: 'Update Driver Duty Status',
      access_driver_get_near_by: 'Get Near By Drivers',
      access_driver_get_booking_history: 'Get Driver Reservation History',
      access_driver_get_location: 'Get Location Of Driver',
      access_driver_get_docs_types: 'Get Driver Document Types',
      access_driver_add: 'Add Driver',
      // hotel bookings
      access_hotel_bookings_grid: 'Hotel Reservations Grid',
      access_hotel_bookings_add: 'Add Hotel Reservations',
      access_hotel_bookings_export_to_xls: 'Hotel Reservations Export To Excel',
      access_hotel_bookings_export_to_pdf: 'Hotel Reservations Export To PDF',
      access_hotel_bookings_list: 'Get All Hotels List',
      // hotels
      access_hotels_activate: 'Activate/Deactivate Hotel',
      access_hotels_booking_grid: 'Get Hotel Reservation History Grid',
      access_hotels_grid: 'Hotels Grid',
      access_hotels_export_to_xls: 'Hotels Export To Excel',
      access_hotels_export_to_pdf: 'Hotels Export To PDF',
      access_hotels_get_count: 'Get Hotels Count',
      access_hotels_search: 'Search Hotel',
      access_hotels_add: 'Add Hotel',
      access_hotels_details: 'Get Hotel Details',
      access_hotels_update: 'Update Hotel',
      // manage departments
      access_dept_update: 'Update Department',
      access_dept_add: 'Add Department',
      access_dept_export_to_xls: 'Departments Grid Export To Excel',
      access_dept_grid: 'Departments Grid',
      access_dept_search: 'Search Employee',
      // manage employee
      access_emp_add: 'Add Employee',
      access_emp_trip_history_grid: 'Employee Trip History Grid',
      access_emp_set_vip: 'Set Employee As VIP',
      access_emp_reject: 'Reject Employee',
      access_emp_approve: 'Approve Employee',
      access_emp_export_to_xls: 'Employees Grid Export To Excel',
      access_emp_activate: 'Activate/Deactivate Employee',
      access_emp_for_pending_approval: 'Get Employee For Pending Approval',
      access_emp_details: 'Get Employee Details',
      access_emp_update: 'Update Employee',
      access_emp_grid: 'Employees Grid',
      // notifications
      access_notification_send: 'Send Notification',
      access_notification_delete_of_user: 'Delete Notifications Of User',
      access_notification_delete: 'Delete Notification',
      access_notification_mark_read: 'Mark Notification Read',
      access_notification_send_status: 'Send Notification Status',
      access_notification_get_list: 'Get Notifications List',
      // passengers
      access_passengers_get_details: 'Get Passenger Details',
      access_passengers_get_trip_history: 'Get Trip History For Passenger',
      access_passengers_get_by_type: 'Get Passengers By Type',
      access_passengers_search: 'Search Passengers',
      access_passengers_grid: 'Passenger Grid',
      access_passengers_get_count: 'Get Passenger Count',
      access_passengers_export_to_xls: 'Passenger Data Export To Excel',
      access_passengers_export_to_pdf: 'Passenger Data Export To PDF',
      access_passengers_activate: 'Active/Deactivate Passenger',
      // sales quotations
      access_sales_quo_accept_reject: 'Accept/Reject Sales Quotation',
      access_sales_quo_upload: 'Upload Sales Quotation',
      access_sales_quo_details: 'Sales Quotation Details',
      access_sales_quo_grid: 'Sales Quotations Grid',
      access_sales_quo_cancel: 'Cancel Sales Quotation',
      access_sales_quo_export_to_xls: 'Sales Quotations Export To Excel',
      access_sales_quo_export_to_pdf: 'Sales Quotations Export To PDF',
      access_sales_quo_view_quotations_details: 'View Quotation Details',
      // staff transport
      access_staff_update: 'Update Staff Transport',
      access_staff_activate: 'Activate/Deactivate Company',
      access_staff_get_drop_points: 'Get Staff Transport Vehicle Drop Points',
      access_staff_add: 'Add Staff Transport',
      access_staff_grid: 'Staff Transport Grid',
      access_staff_details: 'Get Staff Transport Details',
      access_staff_activate_vehicle: 'Activate/Deactivate Staff Transport Vehicle',
      access_staff_count: 'Get Staff Transport Count',
      access_staff_add_booking: 'Add Reservation For Staff Transport',
      access_staff_export_to_xls: 'Staff Transport Export To Excel',
      access_staff_export_to_pdf: 'Staff Transport Export To PDF',
      access_staff_update_status: 'Update Staff Transport Status',
      access_staff_renew_package: 'Renew Staff Transport Package',
      // vehicles
      access_vehicle_get_by_type: 'Get Vehicle By Vehicle Type',
      access_vehicle_get_types: 'Get Vehicle Types',
      access_vehicle_get_service_type: 'Get Service Types',
      access_vehicle_activate: 'Activate/Deactivate Vehicle',
      access_vehicle_grid: 'Vehicles Grid',
      access_vehicle_get_docs_types: 'Get Vehicle Document Types',
      access_vehicle_add: 'Add Vehicle',
      access_vehicle_get_count: 'Get Vehicle Counts',
      access_vehicle_update: 'Update Vehicle',
      access_vehicle_get_details: 'Get Vehicle Details',
      access_vehicle_export_to_xls: 'Vehicles Data Export To Excel',
      access_vehicle_export_to_pdf: 'Vehicles Data Export To PDF',
      access_vehicle_search: 'Search Vehicle',
      access_vehicle_near_by_vehicles: 'Get Near By Vehicles',
      access_vehicle_get_driver_info_by_vehicle: 'Get Driver Info By Vehicle',
      access_vehicle_get_near_by_vehicles_by_area: 'Get Near By Vehicles By Area',
      access_vehicle_booking_history_grid: 'Vehicle Reservation History Grid',
      access_vehicle_add_type: 'Add Vehicle Type',
      access_vehicle_update_type: 'Update Vehicle Type',
      access_vehicle_type_grid: 'Vehicle Types Grid',
      access_vehicle_activate_type: 'Activate/Deactivate Vehicle Type',
      // Bus Menu's
      menu_bus_dashboard: 'Bus Dashboard',
      menu_bus_operators: 'Manage Operators',
      menu_buses: 'Manage Buses',
      menu_bus_routes: 'Manage Routes',
      menu_bus_schedules: 'Manage Schedules',
      menu_bus_tour: 'Manage Tours',
      menu_bus_bookings: 'Manage Reservations',
      menu_bus_refund: 'Manage Refunds',
      menu_bus_seasonal_fare: 'Bus Seasonal Fares',
      menu_bus_seat_layouts: 'Bus Seat Layouts',
      menu_bus_drivers: 'Manage Drivers',
      menu_bus_broadcast_messages: 'Broadcast Messages',
      menu_bus_contents: 'Manage Contents',
      menu_bus_taxes: 'Manage Taxes',
      //
      label_save_assign_tour_info: 'Are you sure do you really want to save the changes?',
      label_start_tour_info: 'Are you sure do you really want to start the tour?',
      label_cancel_tour_info: 'Are you sure do you really want to cancel the tour?',
      label_end_tour_info: 'Are you sure do you really want to end the tour?',
      label_confirm_cancel_booking: 'Are you sure do you really want to cancel this Reservation?',
      label_sign_in_welcome_text: 'Welcome to the transport evolution.',
      label_sign_in_description: 'Shuttle Pulse makes you choose the righteous track to bring boom into your business. ' +
        'Get maximum return on investment by option our complete bus solution. Meet your business requirements with ' +
        'Shuttle Pulse - A superbly designed bus solution.',
      label_read_more: 'Read More',
      signInLabel: 'Sign In',
      error_password_required: 'Password is required',
      label_row_details: 'Details',
      label_refund: 'Refund',
      // Header label
      label_header_dashboard: 'Dashboard',
      label_header_bus_operators: 'Bus Operators',
      label_header_add_operator: 'Add Operator',
      label_header_edit_operator: 'Edit Operator',
      label_header_bus: 'Bus',
      label_header_add_bus: 'Add Bus',
      label_header_edit_bus: 'Edit Bus',
      label_header_bus_routes: 'Bus Routes',
      label_header_view_bus_route: 'View Bus Route',
      label_header_add_bus_route: 'Add Bus Route',
      label_header_edit_bus_route: 'Edit Bus Route',
      label_header_bus_manage_schedule: 'Bus Manage Schedule',
      label_header_view_bus_manage_schedule: 'View Schedule',
      label_header_bus_manage_tours: 'Bus Manage Tours',
      label_header_completed_tours: 'View tour list',
      label_header_assign_bus_driver: 'Assign Bus Drivers',
      label_header_view_tour_details: 'View Tour Details',
      label_header_bus_bookings: 'Manage Bookings',
      label_header_view_bookings: 'View Reservation',
      label_header_add_bookings: 'Add Reservation',
      label_header_cancellation_and_refunds: 'Cancellation And Refunds',
      label_header_view_refund: 'View Refund',
      label_header_bus_seasonal_fares: 'Bus Seasonal Fares',
      label_header_view_seasonal_fares: 'View Seasonal Fares',
      label_header_bus_seat_layouts: 'Bus Seat Layouts',
      label_header_view_seat_layouts: 'View Seat Layouts',
      label_header_add_seat_layouts: 'Add Seat Layouts',
      label_header_bus_drivers: 'Bus Drivers',
      label_header_add_drivers: 'Add Drivers',
      label_header_edit_drivers: 'Edit Drivers',
      label_header_view_drivers: 'View Drivers',
      label_header_manage_taxes: 'Manage Taxes',
      label_header_bus_broadcast: 'Bus Broadcast',
      label_header_about_company: 'About Company',
      label_header_terms_conditions: 'Terms Conditions',
      label_header_privacy_policy: 'Privacy Policy',
      label_header_manage_policy: 'Manage Policy',
      label_header_contact_us: 'Contact Us',
      label_header_cancel_policy: 'Cancel Policy',
      label_empty_message: 'No data found',
      label_header_time_settings: 'Time Settings',
      label_header_support_email_and_number: 'Support Email And Number',

      // placeholder
      placeholder_from_location: 'From location',
      placeholder_to_location: 'To location',
      placeholder_stops: 'Stops',
      placeholder_bus_type: 'Bus type',
      placeholder_operator: 'Operator',
      placeholder_refund_type: 'Refund type',
      placeholder_select_bus: 'Select bus',
      placeholder_select_driver: 'Select driver',

      from_location_required: 'From location is required.',
      to_location_required: 'To location is required.',
      journey_date_required: 'Journey date is required.',
      phone_number_required: 'Phone number is required.',
      phone_code_required: 'Phone code is required.',
      number_only: 'Use numbers only.',
      email_invalid: 'Enter valid email.',
      first_name_required: 'First name is required.',
      last_name_required: 'Last name is required.',
      old_password_required: 'Old Password is required.',
      new_password_required: 'New Password is required.',
      confirm_password_required: 'Confirm Password is required.',
      password_mismatch: 'New password and confirm password mismatch.',
      mins_required: 'Minutes is required.',
      secs_required: 'Seconds is required.',
      hours_required: 'Hours is required.',
      mins_minimum_error: 'Minimum minutes should 0.',
      secs_minimum_error: 'Minimum seconds should 0.',
      hours_minimum_error: 'Minimum hours should 0.',
      mins_maximum_error: 'Minimum minutes should 59.',
      secs_maximum_error: 'Minimum seconds should 59.',

      label_faqs: 'FAQs',
      label_faq_type: 'FAQ type',
      faq_type_req: 'Select FAQ type.',
      file_required: 'Please select file',
      invalid_date_error: 'Date of issue greater than date of expiry',
      aria_label_image_with_unselected_parameter: 'image {{name}} not selected',
      aria_label_image_with_selected_parameter: 'image {{name}} selected',
      placeholder_date_issue: ' Date of issue format mm/dd/yyyy',
      placeholder_date_expiry: ' Date of expiry format mm/dd/yyyy',
      invalid_date_format_error: 'Invalid date format',
      label_user_name: 'User Name',
      label_role_name: 'Role Name',
      label_role_code: 'Role Code',
      label_manage_role: 'Manage Roles',
      error_role_required: 'Role is required.',
      label_add_user: 'Add User',
      label_segment: 'Segment',
      label_message_type: 'Message type',
      label_message_title: 'Subject',
      label_segment_name: 'Segment name',
      label_created_date_time: 'Created date',
      label_contact_match: 'Contact match',
      label_limit_per_user: 'Limit per user',
      label_service_area: 'Service area',
      label_service_type: 'Service type',
      label_segment_list: 'Segment list',
      error_segment_list_required: 'Segment list is required.',
      label_add_new_segment: 'Add new segment',
      label_message_description: 'Message description',
      error_message_type_required: 'Message type is required.',
      error_message_description_required: 'Message description is required.',
      label_role_type: 'Role type',
      error_role_type_required: 'Role type is required.',
      label_segment_required: 'Segment name is required.',
      label_user: 'User',
      error_user_required: 'User is required',
      label_add_segment: 'Add segment',
      label_message_email_description: 'Message email description(required)',
      error_message_title_required: 'Message title is required.',
      label_one_way_or_return: 'One way or return',
      label_need_ada_seats: 'Need ADA seats',
      label_add_return: 'Add return',
      label_duration: 'Duration',
      label_availability: 'Availability',
      label_ada_sold_out: 'ADA sold out',
      label_select_seat: 'Select seats',
      label_sold_out: 'Sold out',
      label_ada_available: 'ADA available',
      label_back_to_search_results: 'Back to search',
      label_seats_available: 'Seats available',
      label_seat_select_head: 'Seat selection',
      label_fare_details: 'Fare details',
      label_seat_legend: 'Seat legend',
      label_ada: 'ADA',
      label_booked: 'Reserved',
      label_total: 'Total',
      label_fare_note: 'Note: Fare may change little based on your trip type. Final fare will reflect while payment',
      label_net_id: 'Net ID',
      label_net_id_required: 'Net id required.',
      invalid_min_date_error: 'Date should not greater than current date',
      invalid_max_date_error: 'Date should not less than current date',
      label_ada_seats: 'ADA seats',
      label_chat: 'Chat',
      menu_chat: 'Admin Chat',
      label_cancel_tour: 'Cancel Tour',
      label_ticket_status: 'Ticket Status',
      label_ticket_number: 'Ticket Number',
      label_passenger_information: 'Passenger Information',
      label_seat: 'Seat',
      label_seat_number: 'Seat Number',
      label_member_ref_id: 'Member reference ID',
      label_payment_by: 'Payment by',
      label_cfop_used: 'CFOP used for payment',
      label_ada_assistance_given: ': Wheelchair accessible seats given',
      label_ticket_cancelled: 'Ticket Cancelled',
      label_via_cfop: 'Paid via CFOP',
      label_via_cc: 'Paid via CARD',
      days_time: 'Days',
      days_minimum_error: 'Minimum days should 0.',
      days_required: 'Day is required',
      label_tour_date: 'Tour date',
      min_length_phone_number: 'Phone number should be 7 to 15 Digit.',
      reason_required: 'Reason is required.',
      error_service_required: 'Service type is required.',
      error_mode_required: 'Mode is required.',
      error_usage_required: 'Usage is required.',
      label_max_discount_required: 'Max discount is required.',
      label_max_discount_pattern: 'Invalid max discount.',
      percent_max_value: 'Maximum value should be 100',
      error_limit_of_uses_required: 'Number of uses required.',
      cnf_really_want_to: 'Are you sure you want to ',
      label_tour_status: 'Tour status',
      error_minimum_mobile_length: 'Minimum length should be 7 digit.',
      error_maximum_mobile_length: 'Maximum length should be 15 digit.',
      error_email_length: 'Maximum length should be 50.',
      label_promo_code_max_length: 'Maximum length should be 15.',
      activate_label: 'activate',
      deactivate_label: 'deactivate',
      menu_view_route: 'View Route',
      menu_view_fare: 'Bus Fares',
      menu_promo_code: 'Promo Codes',
      menu_segments: 'Segments',
      menu_manage_users: 'Manage Users',
      menu_manage_roles: 'Manage Roles',
      label_from_display_name: 'From alias name',
      label_to_display_name: 'To alias name',
      label_stop_display_name: 'Stop alias name',
      display_name_required: 'Alias name required.',
      label_time_message: 'Note: ',
      label_cancel_booking_info: 'Are you sure do you really want to cancel the reservation?',
      placeholder_grid_search: 'Press enter to search ',
      placeholder_from_display_name: 'Enter alias name for source ',
      placeholder_to_display_name: 'Enter alias name for destination ',
      placeholder_stop_display_name: 'Enter alias name for stop',
      label_number_of_bookings: 'Reservation count',
      label_edit_user: 'Edit user',
      menu_customer_feedback: 'Customer Feedback',
      label_cancellation_charges: 'Cancellation Charges',
      label_promo_code_pattern: 'Only alpha numeric allowed.',
      label_business: 'Business',
      label_non_business: 'Non business',
      label_cancellation_note: 'Note: Cancellations must be made at least one hour before your scheduled departure to receive a refund.',
      label_pickup_day: 'Pickup day',
      label_destinations: 'Destination',
      label_stop_details: 'Stop Details',
      label_drop_day: 'Drop day',
      label_drop_time: 'Drop time',
      label_monday_full: 'Monday',
      label_tuesday_full: 'Tuesday',
      label_wednesday_full: 'Wednesday',
      label_thursday_full: 'Thursday',
      label_friday_full: 'Friday',
      label_saturday_full: 'Saturday',
      label_sunday_full: 'Sunday',
      label_water: 'Water',
      label_charging: 'Charging point',
      label_e_ticket: 'E ticket',
      label_wi_fi: 'Wi-Fi',
      label_hammer: 'Hammer',
      label_track_my_bus: 'Track my bus',
      label_air_condition: 'Air condition',
      label_schedule_planner: 'Schedule Planner',
      label_schedule_title: 'Schedule Title',
      label_schedule_planner_req: 'Schedule Planer Required',
      label_schedule_id_req: 'Schedule Id Required',
      label_schedule_title_req: 'Schedule Title Required',
      label_view_feedback: 'View feedback',
      label_guest: 'Guest',
      label_non_guest: 'Non guest',
      label_header_fare_list: 'Fare',
      label_fare_code: 'Fare code',
      label_reported_date: 'Report Date',
      label_update_at: 'Fare Upload Date',
      stop_required: 'Stop name required.',
      stop_alias_required: 'Stop alias name required',
      invalid_from_alias: 'From alias name already used.',
      invalid_to_alias: 'To alias name already used.',
      invalid_stop_alias: 'Stop alias name already used.',
      label_net_id_api_error: 'Please enter valid net Id.',
      error_message_title_length: 'Max 200 characters allowed.',
      error_message_description_thousand_length: 'Max 1000 characters allowed.',
      error_message_description_length: 'Max 200 characters allowed.',
      label_promo_discount: 'Promo Discount',
      label_journey_to_date: 'Journey Date To',
      label_journey_from_date: 'Journey Date From',
      label_confirmed_bookings: 'Confirmed Passengers',
      label_parking_available: 'Is parking available?',
      label_available_count: 'Parking Count',
      label_available_count_required: 'Parking count required.',
      label_checked_in: 'Checked In',
      label_header_parking_code: 'Parking Code',
      label_parking_location: 'Parking Location',
      label_parking_code: 'Parking Code',
      label_parking_code_successfully: 'Parking code save successfully',
      label_service_type_req: 'Service Type (required)',
      label_promo_code_req: 'Promo Code (required)',
      label_mode_req: 'Mode (required)',
      label_discount_req: 'Discount (required)',
      label_max_discount_req: 'Max discount (required)',
      label_usage_req: 'Usage (required)',
      label_no_of_uses_req: 'No. of uses (required)',
      label_usage_limit_req: 'Usage Limit (required)',
      label_per_user_usage_req: 'Usage Limit per User (required)',
      label_Passengers_req: 'Passengers (required)',
      label_start_date_req: 'Start Date (required)',
      label_end_date_req: 'End Date (required)',
      label_segment_list_req: 'Segment list (required)',
      label_message_type_req: 'Message type (required)',
      label_message_description_req: 'Message description (required)',
      label_message_title_req: 'Subject (required)',
      label_message_email_description_req: 'Message email description (required)',
      label_role_type_req: 'Role type (required)',
      label_segment_name_req: 'Segment name (required)',
      label_header_notification: 'Notifications',
      lbl_notifications_not_available: 'Notification not available',
      label_header_profile: 'Profile',
      label_net_id_req: 'Net ID (required)',
      label_first_name_req: 'First Name (required)',
      label_first_name: 'First Name',
      label_last_name_req: 'Last Name (required)',
      label_last_name: 'Last Name',
      label_email_id_req: 'Email (required)',
      lbl_email_id_req: 'Email ID (required)',
      label_country_code_req: 'Country Code (required)',
      label_mobile_no_req: 'Phone No. (required)',
      label_role_req: 'Role (required)',
      label_application_form_req: 'Applicable From (required)',
      label_select_policy_time_format_req: 'Select Policy Time Format (required)',
      label_before_tour_start_req: 'Before Tour start (required)',
      label_percentage_req: 'Percentage (required)',
      label_legend_date_type: 'Select date type',
      aria_label_fare_button: 'Fare button',
      aria_label_deactivate_button: 'Deactivate',
      aria_label_activate_button: 'Activate',
      label_from_parking_available: 'Parking Available',
      label_to_parking_available: 'Parking Available',
      label_from_available_count: 'Parking Count',
      label_to_available_count: 'Parking Count',
      aria_label_chat_button: 'Chat',
      aria_label_edit_button: 'Edit',
      aria_label_send_button: 'Send',
      aria_label_delete_button: 'Delete',
      aria_label_details_button: 'Details',
      aria_label_activity_logs_button: 'Activity Logs',
      aria_label_assign_button: 'Assign',
      aria_label_feedback_button: 'Feedback',
      aria_label_assign_driver_button: 'Assign driver',
      aria_label_view_button: 'View',
      aria_label_notify_button: 'Notify',
      aria_label_save_button: 'Save',
      aria_label_cancel_button: 'Cancel',
      aria_label_end_button: 'End',
      aria_label_start_button: 'Start',
      label_operator_name_req: 'Operator Name (required)',
      label_advance_duration_req: 'Advance Reservation Duration (Days) (required)',
      label_vehicle_name_req: 'Vehicle Name (required)',
      label_type_req: 'Type (required)',
      label_year_req: 'Year (required)',
      label_make_req: 'Make (required)',
      label_model_req: 'Model (required)',
      label_license_plate_req: 'License Plate (required)',
      label_is_ac_req: 'Is AC ? (required)',
      label_upload_image_req: 'Upload Image (required)',
      label_operator_req: 'Operator (required)',
      label_ownership_req: 'Ownership (required)',
      label_layout_type_req: 'Layout Type (required)',
      label_document_type_req: 'Document Type (required)',
      upload_documents_req: 'Upload (required)',
      label_route_title_req: 'Route Title (required)',
      label_from_req: 'From (required)',
      label_from_display_name_req: 'From alias name (required)',
      label_to_req: 'To (required)',
      label_to_display_name_req: 'To alias name (required)',
      email_req: 'Email ID (required)',
      label_address_line_1_req: 'Address line 1 (required)',
      label_country_req: 'Country (required)',
      label_city_req: 'City (required)',
      label_zip_code_req: 'Postal Code (required)',
      lbl_asa_seat0: '0',
      lbl_asa_seat1: '1',
      lbl_asa_seat2: '2',
      lbl_skip_main_content_accessibility: 'Skip to main content',
      label_parking_request: 'Parking request',
      label_parking_msg_content: 'Parking mail content.',
      placeholder_tour_status: 'Tour status',
      label_format_type: 'Format type',
      label_profile_image: 'Profile image',
      label_notifications_available: 'New notifications available',
      label_ada_booking: 'ADA reservations',
      label_header_parking_report: 'Parking Report',
      label_parking_destination: 'Parking location',
      aria_label_reply_button: 'Reply',
      label_customer_feedback: 'Customer feedback',
      label_admin_reply: 'Admin reply',
      header_bookings: 'RESERVATIONS',
      header_driver_locations: 'ACTIVE TRIPS',
      label_booking_count: 'Passengers',
      label_percent_occupancy: '% Occupancy',
      label_ada_count: 'ADA',
      label_tour_name: 'Tour Name',
      label_tour_reason_for_cancel: 'Enter reason for trip cancellation. This reason will be notified to the passengers (required)',
      label_error_cancellation_reason_length: 'cancellation reason should be 200 characters only.',
      label_error_discount_min_value: 'Minimum value of max discount should be 1.',
      access_restricted_bookings_for: 'Restricted Reservations',
      placeholder_restricted_bookings_for: 'Restricted Reservations for',
      header_tour_bookings: 'TOUR RESERVATIONS',
      subject_required: 'Subject is required.',
      error_message_description_2000_length: 'Max 2000 characters allowed.',
      error_message_description_1000_length: 'Max 1000 characters allowed.',
      label_total_passengers: 'Total Passengers',
      label_ada_passengers: 'ADA Passengers',
      label_city_name_req: 'City (required)',
      label_city_name: 'City',
      placeholder_city: 'Enter city name',
      error_city_required: 'City required.',
      label_schedule_expire_on: 'Schedule expire on',
      label_header_top_riders: 'Top Riders',
      label_total_ride: 'Total Rides',
      label_pick_up_passenger_count: 'Pick Up Passenger Count',
      label_drop_passenger_count: 'Drop Passenger Count',
      label_alias_name: 'Alias Name',
      label_header_booking_count_report: 'Reservation Count Report',
      label_schedule_expiry_date: 'Schedule expiry date',
      label_fare_type: 'Fare Type',
      label_block_seat_message: 'Do you want to block this seat? Blocked seats will not be used for bookings.',
      label_unblock_seat_message: 'Are you sure you want to unblock this seat? Unblocked seats will be available for users to book this seat.',
      label_blocked_seat_number: 'Blocked seat number: ',
      error_restricted_key_required: 'Restricted value is required.',
      error_banner_name_required: 'Banner text is required',
      error_select_banner_value: '',
      error_banner_url_required: 'Banner URL is required',
      error_invalid_banner_url: 'Invalid URL',
      label_add_passenger: 'Add Passenger',
      label_edit_passenger: 'Edit Passenger',
      menu_add_passengers: 'Add Passenger',
      menu_edit_passengers: 'Edit Passenger',
      label_add_new_shuttle_schedule: 'Add New Shuttle Schedule',
      label_edit_shuttle_schedule: 'Edit Shuttle Schedule',
      label_create_schedule: 'Create Schedule',
      label_route_schedule: 'Route Schedule',
      label_shuttle_schedule: 'Shuttle Scheduler',
      label_other_details: 'Other Details',
      label_interval_time: 'Interval Time',
      label_frequency_count: 'Frequency Count',
      label_route: 'Route',
      error_route_is_required: 'Route is required.',
      error_schedule_name_is_required: 'Schedule name is required.',
      error_interval_time_is_required: 'Interval time is required.',
      error_frequency_count_is_required: 'Frequency count is required.',
      error_invalid_schedule_name: 'Invalid schedule name.',
      label_route_details: 'Route Details',
      label_this_is_required: "This field is required.",
      label_shuttle_select_operator: 'Select Operator',
      label_download_userguidline: 'Guide',
      label_bulk_import: 'Bulk Import',
      label_upload: 'Upload',
      label_processing: 'Processing',
      label_download_template: 'Template',
      label_download_invalid_file: 'You are trying to download invalid file.',
      label_support_name: 'Support Management',
      label_support_email: 'Support Email',
      label_support_number: 'Support Number',
      label_support_email_number: 'Support Email & Number',
      common_field_req: 'This field is required.',
      error_max_char_limit: 'Character max length exceed.',
      error_max_length_excced: 'Character max length exceed.',
      common_phone_error: 'Please enter valid phone number between 7 to 13 digits and should not start with 0.',
      label_third_party_vendor: 'Third Party Vendor',
      label_limit_pickup_setting: 'Limit Pickup Setting',
      label_header_manage_fare_passes: 'Manage Fare Passes',
      label_add_new: 'Add New',
      label_pass_id: 'Pass ID',
      label_pass_type: 'Pass Type',
      label_start_and_end_date: 'Start & End Date',
      label_pass_type_is_required: 'Pass type is required',
      label_fare_is_required: 'Fare is required',
      label_invalid_fare: 'Invalid Fare',
      label_add_new_pass_fare: 'Add New Pass Fare',
      label_edit_pass_fare: 'Edit Pass Fare',
      label_manage_fare_passes: 'Manage Fare Passes',
      label_manage_passes: 'Manage Passes',
      label_pass_details: 'Pass Details',
      label_pass_qr_code: 'Pass QR Code',
      label_fare_paid: 'Fare Paid',
      label_view_pass_fare: 'View Pass Fare',
      label_schedules: 'Schedules',
      label_from_location: 'From Location',
      label_to_location: 'To Location',
      label_search_by_schedule_name: 'Search by schedule name',
      label_import_shuttle_schedules: 'Import Shuttle Schedules',
      label_from_to_location: 'From & To Location',
      label_from_and_to_date: 'From  & To Date',
      label_daily_shuttles: 'Daily Shuttles',
      label_interval: 'Interval',
      label_shuttle_operator: 'Operator',
      label_manage_fare: 'Manage Fare',
      label_save_fare: 'Save Fare',
      label_base_fare_amount: 'Base Fare Amount',
      label_additional_fares: 'Additional Fares',
      label_all_types: 'All Types',
      label_select_date: 'Select Date',
      label_all_status: 'All Status',
      label_name_label: 'Name / Label',
      label_name_label_placeholder: 'Enter name / label',
      label_calculated_value: 'Calculated Value',
      label_applied_for: 'Applied For',
      label_validity: 'Validity',
      error_max_char_limit_4: 'Character max length exceed',
      error_enter_only_number: 'Please enter only number',
      label_max_50_characters_allowed: 'Max 50 characters allowed',
      common_regex_error: 'Please enter only number',
      label_select_all_to_apply: 'Select all to apply',
      label_select_schedules_to_apply_additional_fare_settings: 'Select schedules to apply additional fare settings',
      label_select_days: 'Select days',
      label_time_range: 'Time range',
      label_value: 'Value',
      label_value_placeholder: 'Enter value',
      label_calculation_in: 'Calculation in',
      label_surge_charge: 'Surge charge',
      label_about_fare_details: 'About fare details',
      label_add_new_additional_fare: 'Add new additional fare',
      label_tax_percentage: 'Tax Percentage',
      label_tax_type: 'Tax Type',
      label_tax_status: 'Tax Status',
      placeholder_from_date: 'From Date',
      placeholder_to_date: 'To Date',
      label_edit_tax: 'Edit Tax',
      label_time_range_placeholder: 'Enter time in HH:MM AM/PM',
      label_header_pass_fares_activity_logs: 'Pass Fares Activity Logs',
      label_action_taken_by: 'Action Taken By',
      label_action_taken_at: 'Action Taken At',
      label_action_taken_role: 'Action Taken Role',
      label_activity_log: 'Activity Log',
      label_edit_additional_fare: 'Edit Additional Fare',
      label_unselect_all_to_apply: 'Unselect all to apply',
      lbl_booking_status: 'Booking Status',
      label_cancel_ticket: 'Cancel Ticket',
      label_tax: 'Tax',
      lbl_email_id_is_required: 'Email ID is required.',
      label_show_stop: 'Show Stop',

      label_version: 'Version',
      lbl_app_release_history: 'App Release History',
      lbl_platform: 'Platform',
      lbl_app: 'App',
      lbl_release_date_and_time: 'Release Date and Time',
      lbl_update_type: 'Update Type',
      lbl_add_new_app_release: 'Add New App Release',
      lbl_edit_new_app_release: 'Edit New App Release',
      lbl_previous_version: 'Previous Version',
      lbl_new_version: 'New Version',
      lbl_app_link: 'App Link',
      lbl_what_new: `What's New`,
      error_version_number: 'Please enter valid version number.',
      lbl_view_app_release_details: 'App Release Details',
      label_general_information: 'General Information',
      lbl_update_type_mandatory: 'Mandatory',
      lbl_update_type_optional: 'Optional',
      lbl_update_type_not_required: 'Not Required',
      label_submit: 'Submit',
      lbl_password_pattern_error: 'Password must be contain at least one digit, uppercase letter, lowercase letter, special symbol with length 8 to 20 characters long.',
      label_update_available: 'Update Available',
      label_new_update_is_available: 'New Update is Available',
      label_release_date: 'Released Date',

    });
  }
}
